var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTickOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5950_19400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9892 81.4735C50.2164 81.6781 50.4832 81.8339 50.7731 81.9312C51.063 82.0285 51.3697 82.0653 51.6744 82.0393C51.979 82.0133 52.2751 81.925 52.5443 81.7799C52.8134 81.6349 53.05 81.4361 53.2392 81.1959L60.8361 71.5475L95.5501 27.5371C96.3265 26.552 97.3204 25.76 98.4539 25.2232C99.5875 24.6864 100.83 24.4193 102.084 24.4428L105.388 24.4022L110.128 24.3345L105.693 31.1459L100.737 38.7225L68.7715 87.5944L59.36 101.495C57.9178 103.526 56.1777 105.679 53.4491 105.679C50.9845 105.679 49.2783 103.905 47.8293 102.199L20.746 72.2652L20.2043 71.5881C19.2211 70.2587 18.7762 68.607 18.9585 66.9636C18.981 66.2208 19.1513 65.4898 19.4595 64.8136C19.7678 64.1373 20.2077 63.5292 20.7536 63.0249C21.2995 62.5206 21.9405 62.1301 22.639 61.8764C23.3376 61.6226 24.0797 61.5106 24.822 61.547C27.3814 61.723 28.4241 62.9011 30.3606 64.4313C35.2762 68.2975 45.7981 77.7089 49.9892 81.4735Z",
    stroke: "url(#paint0_linear_5950_19400)",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5950_19400",
    x1: 30.5777,
    y1: 95.281,
    x2: 103.189,
    y2: 13.8646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#780202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F50000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5950_19400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTickOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick-outline.8e0682ef16a34b708fb748cd38960352.svg";